module.exports = __webpack_public_path__ + "static/media/slide-1.c0f37086.png";